module.exports = __webpack_public_path__ + "static/media/Reference_Point.ecbab8f3.svg";